import NewFolder from "./NewFolder/NewFolder";
import Delete from "./Delete/Delete";
import Copy from "./Copy/Copy";
import { types } from "./types";
import Move from "./Move/Move";

//Enter the switch according to the incoming action names, it renders.
function Actions(action, showAlert, variables, setOpenVariable) {
    switch (action.actionName) {
        case types.NEW: return <NewFolder action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>
        case types.DELETE: return <Delete action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>
        case types.COPY: return <Copy action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>
        case types.MOVE: return <Move action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>
        default: break;
    }
}
export default Actions;